module.exports = __webpack_public_path__ + "static/media/Shape.3da76dde.svg";